import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  NgHeaderTemplateDirective,
  NgNotFoundTemplateDirective,
  NgOptionComponent,
  NgSelectComponent,
} from '@ng-select/ng-select';

import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ValidationFormComponent } from '../validation-form/validation-form.component';
import { SelectOptionsInterface, TranslocoFunction } from '../../types';
import { uiKitScope } from '../../constants/ui-constant';
import { provideUiKitScope } from '../../providers';
import { KeeniconComponent } from '../../partials';
import { ButtonComponent } from '../../misc/button/button.component';

@Component({
  selector: 'ui-form-select',
  imports: [
    NgSelectComponent,
    ReactiveFormsModule,
    NgOptionComponent,
    TranslocoPipe,
    FormsModule,
    ValidationFormComponent,
    TranslocoDirective,
    NgHeaderTemplateDirective,
    NgNotFoundTemplateDirective,
    KeeniconComponent,
    ButtonComponent,
  ],
  templateUrl: './form-select.component.html',
  styleUrl: './form-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
  host: { '[attr.data-cy]': 'dataCy() || null' },
})
export class FormSelectComponent {
  dataCy = input<string>('');
  control = input<AbstractControl>();
  placeholder = input<string>('');
  searchable = input<boolean>(false);
  class = input<string>('');
  isTransloco = input<boolean>(false);
  clearable = input<boolean>(true);
  disabled = input<boolean>(false);
  autoSelectFirst = input<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value = model<any>(null);
  description = input<string>('');
  lockedMessage = input<string>('');
  t = input<TranslocoFunction>();
  dataSelect = input<SelectOptionsInterface[]>([
    { id: 1, name: 'Option 1' },
    { id: 2, name: 'Option 2' },
  ]);
  allowManualEntry = input<boolean>(false);
  manualEntryText = input<string>('');
  manualActionText = input<string>('');
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  valueChange = output<any>();
  closeSelect = output<void>();
  manualEntry = output<string>();
  searchTerm = signal('');

  filteredItems = computed(() => {
    const term = this.searchTerm().toLowerCase();
    const data = this.dataSelect();
    if (!term) return data;
    return data.filter((item) => item.name.toLowerCase().includes(term));
  });

  constructor() {
    effect(() => {
      const options = this.dataSelect();
      const shouldAutoSelect = this.autoSelectFirst();
      const ctrl = this.formControl;

      if (shouldAutoSelect && options?.length) {
        const firstValue = options[0].id;
        ctrl?.setValue(firstValue);
        this.valueChange.emit(firstValue);
        this.value.set(firstValue);
      }
    });
  }

  get formControl(): FormControl {
    return this.control() as FormControl;
  }

  onValueChange(newValue: number) {
    this.valueChange.emit(newValue);
  }

  emitManualEntry() {
    this.manualEntry.emit(this.searchTerm());
  }

  onSearchInput(event: Event) {
    this.searchTerm.set((event.target as HTMLInputElement).value);
  }

  clearSearch() {
    this.searchTerm.set('');
  }

  protected readonly uiKitScope = uiKitScope;
}
